export interface GalleryImage {
  src: string
  alt: string
  caption: string
  category: 'Exterior' | 'Interiors' | 'Pool' | 'Lifestyle'
  orientation: 'landscape' | 'portrait'
}

export const galleryImages: GalleryImage[] = [
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/3fe92389-cc96-42ce-8cf1-c9de13180b6b.jpg',
    alt: 'The apartment building and lit pool at dusk, warm light spilling from the windows',
    caption: 'The grounds at dusk',
    category: 'Exterior',
    orientation: 'landscape',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/ee3f8718-77c7-4460-9496-88c17da9592b.jpg',
    alt: 'A model posing beside an arched window during a photoshoot inside the apartment',
    caption: 'Shoot day, west window',
    category: 'Lifestyle',
    orientation: 'portrait',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/a1147893-9c81-497e-b832-78281b5e8175.jpg',
    alt: 'Three-bedroom apartment living room with boucle sofa and walnut furniture',
    caption: 'Three-bedroom living room',
    category: 'Interiors',
    orientation: 'landscape',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/de45ff2e-59c3-498e-ab11-27d11505d111.jpg',
    alt: 'Pool deck with timber loungers under palms in golden afternoon light',
    caption: 'Pool deck, 5pm',
    category: 'Pool',
    orientation: 'landscape',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/32328f68-c60e-4a6f-b702-fd498cbc2fd3.jpg',
    alt: 'A couple sharing coffee on the terrace at golden hour',
    caption: 'Terrace mornings',
    category: 'Lifestyle',
    orientation: 'portrait',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/b0b77788-0bac-4444-a9d2-1657d0af40fb.jpg',
    alt: 'Master bedroom with cream linen bedding and brass reading lights',
    caption: 'Master bedroom',
    category: 'Interiors',
    orientation: 'landscape',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/5a487925-cc7d-4479-9a08-d3b331fa3eef.jpg',
    alt: 'Friends laughing together on the sofa in the apartment living room',
    caption: 'Long weekend',
    category: 'Lifestyle',
    orientation: 'landscape',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/984178c3-8e5b-4319-a7a8-a7735c9dafc4.jpg',
    alt: 'Open-plan dining and kitchen with marble island and rattan pendants',
    caption: 'Kitchen & dining',
    category: 'Interiors',
    orientation: 'landscape',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/a57927bf-7020-4eb1-b1f1-cc6ba5c242cf.jpg',
    alt: 'Cream stucco and timber facade of the apartment building in daylight',
    caption: 'Facade, morning',
    category: 'Exterior',
    orientation: 'landscape',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/66640e95-349d-4590-91ba-aa1b0338e1f9.jpg',
    alt: 'Arched living area of the two-bedroom suite with oak floors',
    caption: 'Suite living area',
    category: 'Interiors',
    orientation: 'landscape',
  },
]

export const galleryCategories = ['All', 'Exterior', 'Interiors', 'Pool', 'Lifestyle'] as const
export type GalleryCategory = (typeof galleryCategories)[number]
